import React, { useState, useEffect, useContext} from "react";
import { ConquerContext } from "../../../contexts/ConquerContext";
import Loader from "../../../components/LoaderCircle";
import styles from './GameInjector.module.sass';
import CONFIG from "../../../../Core/CONFIG/CONFIG";
import { withRouter } from "react-router";

const GameInjector = ({ gameKey, onExitCallback, history,  location }) => {

    const conquer = useContext( ConquerContext );
    const [gameURL, setGameURL] = useState('');
    const [isLoading, setIsLoading] = useState( false );

    useEffect( () => {

        async function doWork(){

            setIsLoading( true );
            let response = await conquer.Games.getData( gameKey );
            setIsLoading( false );
            let parsedUrl = CONFIG.vars.PUBLIC_FULL_URL + '/' + response.web.substring(0, response.web.lastIndexOf('/'));

            setGameURL( parsedUrl );

        }
        doWork();

    }, [gameKey]);

    useEffect( () => {

        conquer.Signal.get('SKIN:Home', doExit);
        window.addEventListener( 'popstate', doExit );

        history.push( location.pathname );

    }, []);

    const doExit = () => {
        onExitCallback?.();
        conquer.Signal.remove('SKIN:Home', doExit);
    };

    return (
        <div className={styles.container}>
            { isLoading ? <Loader/> : <iframe src={gameURL}></iframe> }
        </div>
    );

};

export default withRouter(GameInjector);